export default function isHoursRange(date, hours) {
	return Date.now() <= new Date(date).getTime() + hours * 60 * 60 * 1000;
}
